import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { useGetEarningById } from '../../../hooks/api/earnings/useGetEarningById'
import { useGetEarningRides } from '../../../hooks/api/earnings/useGetEarningRides'
import { useGetEarningWeeklyReport } from '../../../hooks/api/earnings/useGetEarningWeeklyReport'
import { SortParams } from '../../../types/interfaces'

type EarningsRidesFilters = {
  limit: number
  page: number
  sort: SortParams
}

export const useRides = ({
  limit = 10,
  page = 1,
  sort = {},
}: EarningsRidesFilters) => {
  const { earningId } = useParams()

  const { data: earningStats, isLoading: isLoadingEarningStats } =
    useGetEarningById(Number(earningId))

  const earningRidesFilters = useMemo(
    () => ({
      limit,
      page,
      sort,
    }),
    [limit, page, sort]
  )

  const { data: earningRides, isLoading: isLoadingEarningRides } =
    useGetEarningRides(Number(earningId), earningRidesFilters)

  const { data: earningWeeklyReport, isLoading: isLoadingEarningReport } =
    useGetEarningWeeklyReport(Number(earningId))

  return {
    earningRides: earningRides?.items || [],
    earningRidesPage: earningRides?.current_page || 1,
    earningRidesPerPage: earningRides?.limit || 10,
    earningStats,
    earningWeeklyReport,
    isLoadingEarningReport,
    isLoadingEarningRides,
    isLoadingEarningStats,
    totalEarningRides: earningRides?.total_items || 0,
  }
}
